<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Instagram Official Accounts</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Instagram Accounts</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a
                  ref="formBc"
                  class="btn add-btn"
                  @click="showBroadcast(true)"
                  href="#"
                  data-toggle="modal"
                  data-target="#add_form"
                >
                  <i class="la la-user"></i> Add Account
                </a>
                <a
                  v-show="false"
                  ref="formBcEdit"
                  class="btn add-btn"
                  @click="showBroadcast(false)"
                  href="#"
                  data-toggle="modal"
                  data-target="#add_form"
                >
                  <i class="fa fa-tags"></i> Edit
                </a>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-6">
              <div class="form-group">
                <multiselect
                  v-model="selectedContact"
                  id="ajax"
                  label="license_name"
                  track-by="id"
                  :placeholder="'Type to search Brand...'"
                  :multiple="true"
                  open-direction="bottom"
                  :custom-label="customLabel"
                  :options="contactOptions"
                  :searchable="true"
                  :loading="isLoading"
                  :internal-search="false"
                  :close-on-select="false"
                  :options-limit="300"
                  :limit="3"
                  :limit-text="limitText"
                  :max-height="600"
                  :show-no-results="true"
                  :hide-selected="true"
                  @search-change="asyncFind"
                  :show-labels="false"
                >
                  <template slot="tag" slot-scope="{ option, remove }">
                    <span class="custom__tag">
                      <span>{{option.name}}</span>
                      <span class="custom__remove" @click="remove(option)">❌</span>
                    </span>
                  </template>
                  <template slot="clear" slot-scope="props">
                    <div
                      class="multiselect__clear"
                      v-if="selectedContact.length"
                      @mousedown.prevent.stop="clearAll(props.search)"
                    ></div>
                  </template>
                  <span slot="noResult">Oops! No elements found.</span>
                </multiselect>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input class="form-control floating" v-model="serverParams.username" type="text" />
                <label class="focus-label">Username</label>
              </div>
            </div>

            <!-- <div class="col-sm-6 col-md-6">
              <div class="form-group form-focus">
                <input class="form-control floating" v-model="serverParams.description" type="text" />
                <label class="focus-label">Description</label>
              </div>
            </div>-->

            <div class="col-sm-6 col-md-3">
              <a
                href="javascript:void(0)"
                @click.prevent="filterContactList"
                class="btn btn-success btn-block"
              >Search</a>
            </div>
          </div>
          <div class="row filter-row" v-if="selectedTable.length">
            <div class="col-sm-2 col-md-2">
              <div class="form-group">
                <button
                  @click.prevent="actionUpdateStatus('logout')"
                  :disabled="isLoading"
                  class="btn btn-warning btn-block"
                >
                  <i class="fa fa-sign-out"></i>Logout
                </button>
              </div>
            </div>
            <div class="col-sm-2 col-md-2">
              <div class="form-group">
                <button
                  @click.prevent="actionUpdateStatus('relogin')"
                  :disabled="isLoading"
                  class="btn btn-success btn-block"
                >
                  <i class="fa fa-sign-in"></i> Re-Login
                </button>
              </div>
            </div>
            <div class="col-sm-2 col-md-2">
              <div class="form-group">
                <button
                  @click.prevent="actionDelete"
                  :disabled="isLoading"
                  class="btn btn-danger btn-block"
                >
                  <i class="fa fa-trash"></i> Delete
                </button>
              </div>
            </div>
            <div class="col-sm-6 col-md-6">
              <div class="text-right">
                <!-- <button class="btn btn-success btn-block">Scrape</button>-->
                <a @click.prevent="hideActions" class="btn btn-xs">
                  <i class="fa fa-close"></i> Close
                </a>
              </div>
            </div>
          </div>
          <!-- /Search Filter -->
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <template v-if="contactListArr.length">
                  <div
                    v-for="(row,idx) in contactListArr"
                    :key="idx"
                    class="col-md-12 col-lg-4 col-xl-4 d-flex"
                  >
                    <div class="leave-info-box card flex-fill">
                      <div class="row align-items-center mt-3">
                        <div class="col-12">
                          <div class="row">
                            <div class="col-3 text-center">
                              <a
                                :href="'https://www.instagram.com/'+row.username"
                                target="_blank"
                                class="squared"
                              >
                                <img
                                  style="width:100%"
                                  alt
                                  :src="row.instagram_profile_picture_url"
                                />
                              </a>
                            </div>
                            <div class="col-9">
                              <h4>
                                <router-link
                                  :to="'/instagram/analytics/profile?instagram_id='+row.instagram_id"
                                >{{row.username}}</router-link>
                              </h4>
                              <span class="text-sm text-muted">{{row.instagram_name}}</span>
                            </div>
                          </div>
                          <div class="text-left">
                            <div class="media-body"></div>
                          </div>
                          <table class="table table-striped">
                            <tr>
                              <td style="width:40%;">Posts</td>
                              <td>{{row.total_post}}</td>
                            </tr>
                            <tr>
                              <td style="width:40%;">Followers</td>
                              <td>{{row.total_followers}}</td>
                            </tr>
                            <tr>
                              <td style="width:40%;">Following</td>
                              <td>{{row.total_following}}</td>
                            </tr>
                            <tr>
                              <td style="width:40%;">Reach</td>
                              <td>
                                {{row.reach_in_weeks}}
                                <span class="text-muted">last 7 days</span>
                              </td>
                            </tr>
                            <tr>
                              <td style="width:40%;">Impressions</td>
                              <td>
                                {{row.impressions_in_weeks}}
                                <span class="text-muted">last 7 days</span>
                              </td>
                            </tr>
                          </table>
                          <div class="text-right text-muted">
                            <small>Last Updated: {{timeAgo(row.official_api_update_datetime)}}</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <infinite-loading-contact
                spinner="spiral"
                :identifier="infiniteId"
                @infinite="infiniteHandlerContact"
              >
                <div slot="spinner">
                  <span v-if="loadingMessage">Loading...</span>
                </div>
                <!-- <div slot="no-more">No more messages</div> -->
                <div slot="no-more">
                  <span
                    v-if="(this.serverParams.totalRecords>0 && this.serverParams.rendered>=this.serverParams.totalRecords)"
                  >No more messages</span>
                  <span v-if="(this.serverParams.totalRecords==0)">No more messages</span>
                  <span
                    v-if="(this.serverParams.totalRecords>0 && this.serverParams.rendered==0)"
                  >No more messages</span>
                </div>
                <div slot="no-results">
                  <span v-if="(this.serverParams.totalRecords==0)">No results message</span>
                  <span v-else>No more messages</span>
                </div>
              </infinite-loading-contact>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>

    <form-data />

    <!-- {{selectedContact}} -->
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import FormData from "./formOfficial.vue";

import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import { formatLocalDate, timeAgo } from "@/utils/helper";
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import InfiniteLoading from "vue-infinite-loading";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    FormData,
    Multiselect,
    InfiniteLoadingContact: InfiniteLoading
  },
  data() {
    return {
      currentState: null,
      loadingMessage: true,
      initScrollTop: 0,
      infiniteId: +new Date(),
      initScrollTop: 0,
      selectedTable: [],
      selectedContact: [],
      contactOptions: [],
      contactListParam: {
        name: "",
        page: 0,
        perPage: 20
      },
      isLoading: false,
      isShowModal: false,
      loading: false,
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      allContacts: 0,
      serverParams: {
        official_api_status: "1",
        brand_id: "",
        username: "",
        page: 0,
        perPage: 100,
        rendered: 0,
        totalRecords: 0
      }
    };
    //  isactive : true
  },
  computed: {
    contactListArr() {
      return this.$store.state.instagramAccount.contactListArr;
    },
    selectAllTable: {
      get: function() {
        return this.rows
          ? this.selectedTable.length == this.rows.length
          : false;
      },
      set: function(value) {
        var selectedTable = [];

        if (value) {
          this.rows.forEach(function(row) {
            selectedTable.push(row.id);
          });
        }

        this.selectedTable = selectedTable;
      }
    }
  },
  watch: {
    selectedContact: {
      handler: function(val, oldVal) {
        // console.log("val.id", val.id, val.length);
        if (val.length > 1) {
          let lengthOld = oldVal.length;
          val.splice(0, 1);
          this.selectedContact = val;
        }
        if (val.length == 1) {
          this.serverParams.brand_id = val[0].id;
          this.filterContactList();
          return;
        } else {
          this.serverParams.brand_id = "";
          this.filterContactList();
          return;
        }
      },
      deep: true
    }
  },
  created() {
    this.asyncFind("");
  },
  methods: {
    getUniqueListBy(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()];
    },
    async changeContactListArr(data) {
      var newArr = await this.getUniqueListBy(data, "id");
      await this.$store.dispatch("instagramAccount/setContactListArr", newArr);
    },
    async filterContactList() {
      this.changeContactListArr([]);
      this.serverParams.totalRecords = 0;
      this.serverParams.rendered = 0;
      this.serverParams.page = 0;
      this.serverParams.perPage = 100;
      // this.serverParams.brand_id = "";
      this.infiniteId += 1;
    },
    async infiniteHandlerContact($state) {
      // console.log("staaate", $state);
      this.loadingMessage = await true;
      // if (this.contactListParam.group_id.length == 0) {
      //   this.allContacts = "";
      // }
      await this.$store
        .dispatch("instagramAccount/listOfficial", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          if (data != null && data.length) {
            data.forEach((row, idx) => {
              this.$store.dispatch(
                "instagramAccountOfficial/updateUserStats",
                row.instagram_id
              );
            });
          }
          // console.log("dataaa", data);
          this.newData = data;

          if (this.newData.length > 0) {
            this.contactListArr.push(...this.newData);
            this.changeContactListArr(this.contactListArr);
            this.serverParams.rendered =
              this.serverParams.page + response.recordsFiltered;
            this.serverParams.page += response.recordsFiltered;
            if (response.totalRecords > 0) {
              this.serverParams.totalRecords = response.totalRecords;
            }

            this.loadingMessage = false;
            // this.infiniteHandler(this.currentState, 0, 0);
            $state.loaded();
          } else {
            this.loadingMessage = false;
            $state.completed();
          }
        })
        .catch(error => {
          //   this.loading = false;
          this.loadingMessage = false;

          console.log("error", error);
        });
    },
    hideActions() {
      this.selectAllTable = false;
      this.selectedTable = [];
    },
    actionUpdateStatus(actionValue) {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000
        });
        return;
      }
      this.isLoading = true;
      this.$fire({
        title:
          "Are you sure you want to " +
          actionValue +
          " " +
          this.selectedTable.length +
          " accounts?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable,
              action: actionValue
              // status: statusValue
            };
            this.$store
              .dispatch("instagramAccount/actionStored", newParam)
              .then(response => {
                this.$fire({
                  title: "Success " + actionValue,
                  text: "The data was successfully " + actionValue,
                  type: "success",
                  timer: 2000
                });
                this.isLoading = false;
                this.selectedTable = [];
                this.selectAllTable = false;
                this.filterContactList();
              })
              .catch(e => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    actionDelete() {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000
        });
        return;
      }
      this.isLoading = true;
      this.$fire({
        title:
          "Are you sure you want to permanently erase " +
          this.selectedTable.length +
          " items?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable,
              action: "delete"
            };
            this.$store
              .dispatch("instagramAccount/actionStored", newParam)
              .then(response => {
                this.$fire({
                  title: "Success Delete",
                  text: "The data was successfully deleted",
                  type: "success",
                  timer: 2000
                });
                this.isLoading = false;
                this.selectedTable = [];
                this.selectAllTable = false;
                this.filterContactList();
              })
              .catch(e => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    timeAgo(unixTime) {
      return timeAgo(unixTime);
    },
    formatLocalDate(unixTime) {
      return formatLocalDate(unixTime);
    },
    limitText(count) {
      return `and ${count} other`;
    },
    customLabel({ name }) {
      return `${name}`;
    },
    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.name = query;
      this.$store
        .dispatch("brand/list", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    clearAll() {
      this.selectedContact = [];
    },
    async copyData(id) {
      //set false dulu
      this.$store.dispatch("instagramAccount/setIsShowForm", false);
      let formData = await {};
      await this.$store
        .dispatch("instagramAccount/detailEdit", id) // sesuai kan dengan method di API
        .then(response => {
          var { data } = response;
          formData = data;
        });
      console.log("formData::", formData);
      formData.copy = true;
      await this.$store.dispatch("instagramAccount/actFormParamSt", formData);
      // this.showBroadcast();
      var elem = this.$refs.formBcEdit;
      elem.click();
    },
    async detailData(id) {
      //set false dulu
      this.$store.dispatch("instagramAccount/setIsShowForm", false);
      let formData = await {
        copy: false,
        id: "",
        brand_id: [],
        brand_selected: [],
        ig: {
          id: "",
          username: "",
          password: ""
        }
      };
      await this.$store
        .dispatch("instagramAccount/detailEdit", id) // sesuai kan dengan method di API
        .then(async response => {
          var { data } = response;
          // console.log("response::", response);
          // console.log("data::", data);

          formData = data;
          // formData.brand_id = [];
          // await data.brand_selected.forEach((row, idx) => {
          //   formData.brand_id[idx] = row.brand_id;
          //   console.log("formData.brand_id::", formData.brand_id, row.brand_id);
          // });
          // console.log("formData::", formData);
        });
      // console.log("formData::", formData);
      formData.id = id;
      formData.ig.id = id;
      await this.$store.dispatch("instagramAccount/actFormParamSt", formData);
      // this.showBroadcast();
      var elem = this.$refs.formBcEdit;
      elem.click();
    },

    showBroadcast(newData) {
      if (typeof newData != "undefined" && newData == true) {
        this.$store.dispatch("instagramAccount/setIsShowForm", false);

        let formData = {
          brand_id: [],
          ig: {
            id: "",
            username: "",
            password: ""
          },
          brand_selected: []
        };
        this.$store.dispatch("instagramAccount/actFormParamSt", formData);
      }
      var that = this;
      setTimeout(function() {
        var liContainer = document.getElementById("add_form");
        var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal", isShowModal);
        // this.$root.$emit("infiniteHandlerContact");
        if (isShowModal == true) {
          that.$store.dispatch("instagramAccount/setIsShowForm", true);
        }
      }, 1000);
    }
  },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "broadcast-list"
};
</script>


// WEBPACK FOOTER //
// src/views/instagram/instagramAccount/listOfficial.vue